import { InboxNotificationDetailsResponse } from 'src/entities/Notifications';
import { API } from 'src/utils/AmplifyApiUtils';

export const INBOX_NOTIFICATIONS_PAGE_SIZE = 100;

export default class InboxClient {
  static async loadPaginatedNotifications(
    notifications: InboxNotificationDetailsResponse[],
    pagesToLoad = Infinity,
    nextToken: string | undefined = undefined,
  ): Promise<InboxNotificationDetailsResponse[]> {
    const getNotificationsResponse = await API.get('AppAPI', `/notifications`, {
      queryStringParameters: {
        nextToken,
        limit: INBOX_NOTIFICATIONS_PAGE_SIZE,
      },
    });

    const allNotifications = [
      ...notifications,
      ...(getNotificationsResponse.data ?? []),
    ];

    if (pagesToLoad <= 1 || !getNotificationsResponse.nextToken) {
      return allNotifications;
    }

    return this.loadPaginatedNotifications(
      allNotifications,
      pagesToLoad - 1,
      getNotificationsResponse.nextToken,
    );
  }
}
